export const LIMIT_FORMATS = {
  infinity: '\u221e',
  empty: /^$/,
  numbersOrInfinity: /([0-9]+\u221e)|(\u221e[0-9]+|([0-9]+))/,
};

export const SCHEDULING_GROUPS = {
  defaultGroup: 'Default',
};
